import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREFEQ_Escrow_Release_Package.css';

const PREFEQ_Escrow_Release_Package = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREFEQ_ESCROW_RELEASE_PACKAGE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREFEQ_ESCROW_RELEASE_PACKAGE:-1
  });


  const [PREFEQ_ESCROW_RELEASE_PACKAGE, setPREFEQ_ESCROW_RELEASE_PACKAGE] = React.useState(null);
  const [PREFEQ_ESCROW_RELEASE_PACKAGE_D, setPREFEQ_ESCROW_RELEASE_PACKAGE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Preferred Equity Token Escrow Release Package');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREFEQ_ESCROW_RELEASE_PACKAGE(clientInfo,"OpenNew");

		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREFEQ_ESCROW_RELEASE_PACKAGE(clientInfo,"OpenNew");
		}
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
		if(Temp_Data2.status!="New"){
			handleDeletePREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data2);
			navigate('/PREFEQ_Escrow_Release_Package#New',{replace:true});
		} 
		else 
			navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREFEQ_Escrow_Release_Package',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREFEQ_ESCROW_RELEASE_PACKAGE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_${i}_SECTION`;
	  const headerId = `#PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREFEQ_ESCROW_RELEASE_PACKAGE]) ;


  
  
  var Ids = [];
  for(var Ele in PREFEQ_ESCROW_RELEASE_PACKAGE){
	  for(var Sec in PREFEQ_ESCROW_RELEASE_PACKAGE[Ele]){
		if(Sec == "id")
			Ids.push(PREFEQ_ESCROW_RELEASE_PACKAGE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREFEQ_ESCROW_RELEASE_PACKAGE[Ele]["status"]);
		else if(Array.isArray(PREFEQ_ESCROW_RELEASE_PACKAGE[Ele][Sec]))
			  for(var Row in PREFEQ_ESCROW_RELEASE_PACKAGE[Ele][Sec])  // Convert to PREFEQ_ESCROW_RELEASE_PACKAGE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREFEQ_ESCROW_RELEASE_PACKAGE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREFEQ_ESCROW_RELEASE_PACKAGE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREFEQ_ESCROW_RELEASE_PACKAGE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE`).then((response1) => {
		if(!PREFEQ_ESCROW_RELEASE_PACKAGE) 
			setPREFEQ_ESCROW_RELEASE_PACKAGE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE_D`).then((response2) => {
			setPREFEQ_ESCROW_RELEASE_PACKAGE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREFEQ_ESCROW_RELEASE_PACKAGE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREFEQ_ESCROW_RELEASE_PACKAGE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREFEQ_ESCROW_RELEASE_PACKAGE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREFEQ_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREFEQ_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREFEQ_ESCROW_RELEASE_PACKAGE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_ESCROW_RELEASE_PACKAGE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["1"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("1","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["2"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("2","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["2"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("2","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
  
      
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["3"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("3","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


  
      
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["3"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("3","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["4"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("4","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["4"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1"]=value;
	Form_Data_onChange("4","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4"]=value;
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["5"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("5","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  

const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0"]=value;
	Form_Data_onChange("9","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
  }; 
  

    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
	Temp_Data["9"]["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4"]=value;
	//handleAddPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data,App_Data['PREFEQ_ESCROW_RELEASE_PACKAGE']);
	Form_Data_onChange("9","PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4",value,Temp_Data);
 	//handleLastDataPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
    setPREFEQ_ESCROW_RELEASE_PACKAGE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREFEQ_ESCROW_RELEASE_PACKAGE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREFEQ_ESCROW_RELEASE_PACKAGE =JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
  updatedPREFEQ_ESCROW_RELEASE_PACKAGE[Sec] = [...updatedPREFEQ_ESCROW_RELEASE_PACKAGE[Sec], newRow];
  setPREFEQ_ESCROW_RELEASE_PACKAGE(updatedPREFEQ_ESCROW_RELEASE_PACKAGE);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREFEQ_ESCROW_RELEASE_PACKAGE = JSON.parse(JSON.stringify(PREFEQ_ESCROW_RELEASE_PACKAGE));
  updatedPREFEQ_ESCROW_RELEASE_PACKAGE[sec].splice(index, 1);
  setPREFEQ_ESCROW_RELEASE_PACKAGE(updatedPREFEQ_ESCROW_RELEASE_PACKAGE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Preferred Equity Token Escrow Release Package`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Preferred Equity Token Escrow Release Package ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREFEQ Escrow Release Package ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0" type="text" className="form-control" placeholder="PREFEQ Escrow Release Package ID" value={PREFEQ_ESCROW_RELEASE_PACKAGE["1"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREFEQ Escrow Release Package ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1" type="text" className="form-control" placeholder="Offering ID" value={PREFEQ_ESCROW_RELEASE_PACKAGE["1"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2" type="text" className="form-control" placeholder="Milestone ID" value={PREFEQ_ESCROW_RELEASE_PACKAGE["1"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Milestone ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Inspection Report ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3" type="text" className="form-control" placeholder="Inspection Report ID" value={PREFEQ_ESCROW_RELEASE_PACKAGE["1"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Inspection Report ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Requested Release Amount USD`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested Release Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0" type="text" className="form-control" placeholder="Requested Release Amount USD" value={PREFEQ_ESCROW_RELEASE_PACKAGE["2"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Requested Release Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved Release Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1" type="text" className="form-control" placeholder="Approved Release Amount USD" value={PREFEQ_ESCROW_RELEASE_PACKAGE["2"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Approved Release Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Lien Waivers Complete`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Lien Waivers Complete`)} <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0_Change} 
					  checked={PREFEQ_ESCROW_RELEASE_PACKAGE?.["3"]?.["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0"] === "true" || PREFEQ_ESCROW_RELEASE_PACKAGE?.["3"]?.["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Budget Variance Acceptable`)} <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1_Change} 
					  checked={PREFEQ_ESCROW_RELEASE_PACKAGE?.["3"]?.["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1"] === "true" || PREFEQ_ESCROW_RELEASE_PACKAGE?.["3"]?.["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_3_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Investor Notice Link`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor Notice Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0" type="text" className="form-control" placeholder="Investor Notice Link" value={PREFEQ_ESCROW_RELEASE_PACKAGE["4"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Investor Notice Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Release Recommendation`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1"  value={PREFEQ_ESCROW_RELEASE_PACKAGE["4"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1`]} onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_4_1_Change} className="form-control" name="Release Recommendation"  >
						  <option value="Release Full Amount">Release Full Amount</option>
						  <option value="Release Partial Amount">Release Partial Amount</option>
						  <option value="Hold Funds">Hold Funds</option>
						  <option value="Reject Release">Reject Release</option>
						  <option value="Escalate">Escalate</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Release Recommendation
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0" type="text" className="form-control" placeholder="Submitted By" value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1" type="text" className="form-control" placeholder="Submitted At" value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4"  value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4`]} onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={PREFEQ_ESCROW_RELEASE_PACKAGE["5"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0"  value={PREFEQ_ESCROW_RELEASE_PACKAGE["9"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0`]} onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1" type="text" className="form-control" placeholder="Created By" value={PREFEQ_ESCROW_RELEASE_PACKAGE["9"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2" type="text" className="form-control" placeholder="Created At" value={PREFEQ_ESCROW_RELEASE_PACKAGE["9"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3" type="text" className="form-control" placeholder="Updated By" value={PREFEQ_ESCROW_RELEASE_PACKAGE["9"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4" type="text" className="form-control" placeholder="Updated At" value={PREFEQ_ESCROW_RELEASE_PACKAGE["9"][`PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4`]} 
						onChange={PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_04_INSPECTION_ESCROW_CAPITAL_RELEASE_PREFEQ_ESCROW_RELEASE_PACKAGE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREFEQ_Escrow_Release_Package;  